/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import FormGroup from "../../ui/form/FormGroup";
import FormError from "../../ui/form/FormError";
import TextField from "../../ui/form/TextField";
import EmailField from "../../ui/form/EmailField";
import PhoneField from "../../ui/form/PhoneField";
import { useConfig } from "../../../lib/react-query/useConfig";
import { useCompany } from "../../../lib/react-query/useCompany";
import { useAuth } from "../../../hooks/useAuth";

const GuestClientFields = ({ control, errors }) => {
  const { data: config } = useConfig();
  const { data: company } = useCompany();
  const { client } = useAuth();

  const isEmailRequired = config?.client_email_required;
  const isPhoneRequired = config?.client_phone_required;

  return (
    <>
      <FormGroup>
        <TextField
          control={control}
          name="name"
          label="name"
          placeholder="enter_name"
          required={true}
          defaultValue={client?.name}
        />
        {errors?.name && <FormError name="name">{errors.name.message}</FormError>}
      </FormGroup>
      <FormGroup>
        <EmailField
          control={control}
          name="email"
          label="email"
          placeholder="enter_email"
          required={isEmailRequired}
          defaultValue={client?.email}
        />
        {errors?.email && <FormError name="email">{errors.email.message}</FormError>}
      </FormGroup>
      <FormGroup>
        <PhoneField
          control={control}
          prefixChangable={config?.country_prefix_is_changeable}
          name="phone"
          label="phone"
          placeholder="enter_phone"
          country={(config?.country_prefix_id || config?.country_phone_initial || company?.country_id)?.toLowerCase()}
          required={isPhoneRequired}
          defaultValue={client?.phone}
        />
        {errors?.phone && <FormError name="phone">{errors.phone.message}</FormError>}
      </FormGroup>
    </>
  );
};

export default GuestClientFields;
